module.exports = __webpack_public_path__ + "img/rooms-buttons-add.ed75b514.svg";